export default __webpack_public_path__ + "static/media/product_card3_Cn.ab92de97.webp";